import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import { AreaChart, ChartYHanle } from './common';

export class MTBFChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "平均无故障时间";
        this.unit = "分钟";
        this.yName = "MTBF[min]";
        this.yHanle = ChartYHanle.numerical;
    }

    getMarkData() {
        return { handle: "last" };
    }
}

export class LastMTBFChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "平均无故障时间";
        this.unit = "分钟";
        this.yName = "MTBF[min]";
        this.yHanle = ChartYHanle.numerical;
    }

    getX() {
        return [15, 30, 45, 60];
    }
}